import React from 'react';
import 'styles/components/menu/business/SystemIntegrationTab.scss';
import businessPerformance2 from 'assets/data/businessPerformance2.json';

const SystemIntegrationTab = () => {
    return (
        <section className='SystemIntegrationTab'>
            <div className="SystemIntegrationTab-wrapper">
                <div className="title">
                    다양한 분야의
                    <br className='lineBreak pc' />
                    <span className='fw_bold'> 서비스를 통합/운영</span>함으로
                    <br className='lineBreak' />
                    서비스에 새로운 <span className='fw_bold'>가치를 창출</span>합니다
                </div>
                <div className="contentBox">
                    <div className="contentBox-text">
                        <p>
                            어질인소프트는 다양한 프로젝트 구축 성공사례를 통해<span className='fc_red'> 축적된 역량과 노하우로 고객의 Needs와 IT환경을 분석∙파악</span>하여 <br className='lineBreak' />
                            <span className='fc_red'>최상의 시스템통합(SI) 서비스를 제공</span>합니다.
                        </p>
                        <p>
                            고객 최우선의 <span className='fw_bold'>명확한 목표를 설정</span>하고, 경험이 풍부한 <span className='fw_bold'>우수 인력을 보유</span>하고 있으며, 기술력을 가치로 생각하는<br className='lineBreak' />
                            <span className='fw_bold'> 협력사와의 협업</span>을 통하여, <span className='fw_bold'>납기일 준수와 고품질 서비스 제공</span>으로 <span className='fw_bold'>고객에게 최고의 가치를 전달</span>합니다.
                        </p>
                    </div>
                    <div className="circles">
                        <div className="circles-wrapper">
                            <div className="mainCircle">
                                <p className='mainCircle-title'>시스템통합</p>
                                <p className='mainCircle-text'>(System Integration)</p>
                            </div>
                            <div className="circle circle1">전문적인<br />자원</div>
                            <div className="circle circle2">체계적 개발<br />프로세스</div>
                            <div className="circle circle3">성능최적화<br />및 신기술</div>
                            <div className="circle circle4">개발기간 및<br />비용 최적화</div>
                            <div className="circle circle5">안정적<br />운영</div>
                            <div className="circle circle6">고객지향적<br />시스템</div>
                        </div>
                    </div>
                    <div className="performance">
                        <div className="performance-title">주요사업 실적</div>
                        <table className="performance-table">
                            {businessPerformance2.map((item, idx) =>
                                <tbody key={idx}>
                                    <tr>
                                        <td className='table-name'>{item.name}</td>
                                        <td className='table-content'>{item.content.length > 1 ?
                                            item.content.map(content => content + '\n')
                                            : item.content}</td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default React.memo(SystemIntegrationTab);